import {
  AssetInternalCommentsControllerGetAssetCommentsParams,
  GetAssetVersionCommentsSuccessDto
} from '@api/Api';
import { assetInternalCommentsGetAssetComments } from '@api/Asset';
import { getPlaceholderQuery } from '@hooks/queries/helpers';
import { useQuery } from '@tanstack/react-query';

export const QUERY_COMMENTS_ASSETS = 'comments_assets';

export function useInternalCommentsAssetReviewQuery(
  params: AssetInternalCommentsControllerGetAssetCommentsParams,
  options?: {
    enabled?: boolean;
    keepPreviousData?: boolean;
    placeholderData?: GetAssetVersionCommentsSuccessDto;
  }
) {
  const queryKey = [QUERY_COMMENTS_ASSETS, params.assetVersionId];
  return useQuery({
    ...(options ?? {}),
    queryKey,
    queryFn: async ({ signal }) => {
      const { data } = await assetInternalCommentsGetAssetComments(params, {
        signal
      });
      return data;
    },
    placeholderData: () => {
      if (options?.placeholderData) return options.placeholderData;
      return getPlaceholderQuery<GetAssetVersionCommentsSuccessDto>(
        queryKey,
        (data): data is GetAssetVersionCommentsSuccessDto =>
          !!data &&
          typeof data === 'object' &&
          Array.isArray((data as GetAssetVersionCommentsSuccessDto).comments)
      );
    }
  });
}
